<script lang="ts" setup>
defineProps<{
  hasCsv: boolean
  hasErrors: boolean
  busy: boolean
  showImport: boolean
}>()

// const emit = defineEmits<{
//   clear: []
//   validate: []
//   import: []
// }>()
const emit = defineEmits(['clear', 'validate', 'import']) // typed version of defineEmits doesn't work in 2.7
</script>

<template>
  <div class="bulk-actions d-flex justify-content-between">
    <button class="btn btn-outline-secondary" @click="emit('clear')" :disabled="busy">
      Clear
    </button>
    <div>
      <button
        class="btn btn-outline-primary mr-2"
        @click="emit('validate')"
        :disabled="!hasCsv || busy"
      >
        Validate
      </button>
      <button
        class="btn btn-primary"
        @click="emit('import')"
        :disabled="!hasCsv || hasErrors || busy || !showImport"
      >
        Import
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bulk-actions {
  margin-top: 1rem;
}
</style>
